<template>
  <el-form
    ref="form"
    v-loading="loading"
    :model="form"
    :rules="rules"
    label-width="50px"
    inline
    style="display: flex; flex-direction: column"
  >
    <div>
      <el-form-item label="名称" prop="fName">
        <el-input v-model="form.fName" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.fDes" style="width: 400px" />
      </el-form-item>
      <el-form-item v-if="canEdit">
        <el-button type="primary" :disabled="saving" @click="submit"
          >保存<span v-if="saving">中...</span></el-button
        >
        <!-- <el-button v-if="canAdd" @click="refreshNew">新增</el-button> -->
      </el-form-item>
    </div>
    <el-table
      v-el-table-height-fix
      :data="form.entrys"
      style="width: 100%"
      height="100%"
    >
      <el-table-column width="80">
        <template slot="header">
          <div style="display: flex; align-items: center">
            操作
            <i
              class="el-icon-circle-plus-outline"
              style="
                color: #409eff;
                font-size: 18px;
                margin-left: 5px;
                cursor: pointer;
              "
              title="添加行"
              @click="addRow"
            />
          </div>
        </template>
        <template slot-scope="scope">
          <div class="tools">
            <el-popconfirm title="是否删除？" @confirm="delRow(scope.$index)">
              <i slot="reference" class="el-icon-remove-outline" title="删除" />
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="产品编号" label-class-name="font-color-red">
        <template slot-scope="scope">
          <el-select-table
            v-model="scope.row.ficItemID"
            :label.sync="scope.row.fNumber"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fNumber"
            value-field="ficItemID"
            :extra-param="{ prohibit: true }"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
            @change="fNumberChange(scope.row, $event)"
          />
        </template>
      </el-table-column>
      <el-table-column label="产品名称" prop="fName" />
      <el-table-column
        label="数量"
        label-class-name="font-color-red"
        width="120px"
      >
        <template slot-scope="scope">
          <el-input-currency v-model="scope.row.fQty" :scale="0" min="0" />
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
export default {
  inject: ["getMap"],
  components: {},
  data: function () {
    return {
      form: {},

      rules: {},

      loading: false,
      saving: false,
      isNew: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.routePath || vm.routePath != to.fullPath) {
        vm.routePath = to.fullPath;
        vm.refresh();
      }
    });
  },
  beforeRouteUpdate: function (to, from, next) {
    next();
    const vm = this;
    vm.routePath = to.fullPath;
    vm.refresh();
  },
  computed: {
    canEdit: function () {
      const userGrants = this.$store.state.userInfo.userGrants;
      let isgrant = null;
      let isgrant2 = null;
      let sum = null;
      userGrants.forEach((val) => {
        if (val.key == "002002003") {
          isgrant = val.isGrant;
        }
        if (val.key == "002002002") {
          isgrant2 = val.isGrant;
        }
      });

      if (isgrant || isgrant2) {
        sum = true;
      } else {
        sum = false;
      }
      return sum;
    },
    // canAdd: function() {
    //   const userGrants = this.$store.state.userInfo.userGrants
    //   // return userGrants.some(x => x.key == '002002003')
    //   let isgrant = null
    //   userGrants.forEach(val => {
    //     if (val.key == '002002002') {
    //       isgrant = val.isGrant
    //     }
    //   })
    //   return isgrant
    // }
  },
  methods: {
    fNumberChange: function (item, item2) {
      item.fName = item2 ? item2.fFullName : null;
    },

    submit: async function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saving = true;
          const isNew = this.form.ficItemZhID == 0;
          this.$httpPost("ICItemManage/ICItemZh/ICItemZhModify", {
            datalist: JSON.stringify({
              modifyType: isNew ? 0 : 1,
              info: this.form,
            }),
          })
            .then((res) => {
              if (!res.isSuccess) {
                this.$message.error(res.message);
                return;
              }

              // 重新刷新页面数据
              this.$message.success(res.message);
              this.refresh(res.datalist)
            })
            .finally(() => (this.saving = false));
        } else {
          return false;
        }
      });
    },

    addRow: function () {
      // console.log('addRow');
      const entrys = this.form.entrys;
      entrys.push({
        ficItemID: null,
        fNumber: null,
        fName: null,
        fQty: 0,
      });
    },
    delRow: function (index) {
      // console.log('delRow');
      const entrys = this.form.entrys;
      entrys.splice(index, 1);
    },

    refresh: async function (fid) {
      const id = fid || +this.$route.params.id;
      this.isNew = !id;
      if (id == 0) {
        this.form = {
          ficItemZhID: 0,
          fName: null,
          fDes: null,
          entrys: [],
        };
        // 保证页面至少有10行
        for (let i = 0; i < 10; i++) {
          this.addRow();
        }
        return;
      }

      this.loading = true;
      const res = await this.$httpPost("ICItemManage/ICItemZh/GetICItemZh", {
        fid: id,
      }).finally(() => (this.loading = false));

      if (!res.isSuccess) {
        this.$message.error(res.message);
        return;
      }

      this.form = res.datalist;

      const entrys = this.form.entrys;

      // 保证页面至少有10行
      const rowsToAdd = 10 - entrys.length;
      for (let i = 0; i < rowsToAdd; i++) {
        this.addRow();
      }
    },
    refreshNew: function () {
      const id = +this.$route.params.id;
      if (id == 0) {
        this.refresh();
        return;
      }
      this.$router.push("./0");
    },
  },
};
</script>

<style lang="less" scoped>
.tools i {
  margin-right: 5px;
  cursor: pointer;
  color: #409eff;
  font-size: 18px;
}
</style>
